'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes$1 = _interopDefault(require('prop-types'));
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('lodash/get');
var _babelHelpers = require('./_babelHelpers-48e7a7f7.js');
var settings = require('./settings-9ee2f03f.js');
var sharedComponents = require('./shared-components.js');
var select = require('./dropdown/select.js');
require('./constants-53160533.js');
var country = require('./dropdown/country.js');
var global = require('./style/global.js');
var search = require('./dropdown/search.js');
require('./browser-05a2bba8.js');
require('react-dom');
require('./_commonjsHelpers-3fc1f64e.js');
require('./_react_commonjs-external-30e5c7b3.js');
require('./_prop-types_commonjs-external-c51b2bd5.js');
require('./style-cf128dc7.js');
var text = require('./input/text.js');
require('lodash/isRegExp');
require('lodash/replace');
var prevent = require('./input/prevent.js');
require('./style-222d2b0f.js');
var b14 = require('./typography/b14.js');
require('lodash/camelCase');
require('lodash/upperFirst');
var icon = require('./icon.js');
var textarea = require('./input/textarea.js');
var password = require('./input/password.js');
require('./number_format-33e3898d.js');
var formatted = require('./input/formatted.js');
var internationalPhone = require('./input/international-phone.js');
require('./style-inject.es-dcee06b6.js');
var hr = require('./hr.js');
require('lodash/isArray');
require('./panel-styles-275a918b.js');
var alert = require('./alert.js');
require('./polished.es-a11ee845.js');
var checkbox = require('./input/checkbox.js');
var span = require('./typography/span.js');
require('lodash/omit');
require('./style-17209f53.js');
var b18 = require('./typography/b18.js');
var b16 = require('./typography/b16.js');
var radioButton = require('./input/radio-button.js');
var radioTextarea = require('./input/radio-textarea.js');
require('lodash/isNil');
var s24 = require('./typography/s24.js');
require('lodash/isFunction');
var radioConditionalField = require('./input/radio-conditional-field.js');
var s16 = require('./typography/s16.js');
var radioButtonCard = require('./input/radio-button-card.js');
require('./styles-ab893f86.js');
require('./index-4b81da60.js');
require('./invariant-8c441586.js');
require('./react-lifecycles-compat.es-59afd828.js');
require('./_react-dom_commonjs-external-3c49a59a.js');
var transparent = require('./button/transparent.js');
var container = require('./array-field-group/container.js');
var s18 = require('./typography/s18.js');
var item = require('./array-field-group/item.js');
var index$1 = require('./array-field-group/index.js');
require('./index-db6682ea.js');
var text$1 = require('./terms/text.js');
var box = require('./terms/box.js');
var section = require('./terms/section.js');
var list = require('./terms/list.js');
var usState = require('./dropdown/us-state.js');
require('lodash/findIndex');
var stepProgress = require('./step-progress.js');
var t24 = require('./typography/t24.js');
require('./buttons-color-d198c1b7.js');
var buttonIcon = require('./button/button-icon.js');
var mobileInfoOverlay = require('./mobile-info-overlay.js');
var tags = require('./input/tags.js');
require('./ua-parser-40543b9b.js');
require('lodash/cloneDeep');
var withTrail = require('./input-group/with-trail.js');
var slider = require('./input/slider.js');
var t36 = require('./typography/t36.js');
var t20 = require('./typography/t20.js');
var s20 = require('./typography/s20.js');
var date = require('./input/date.js');
var index$3 = require('./button/index.js');
var gradient = require('./button/gradient.js');
var back = require('./button/back.js');
var redButton = require('./button/red-button.js');
var link = require('./button/link.js');
var _switch = require('./button/switch.js');
var infoBox = require('./info-box.js');
require('lodash/merge');
require('./tooltip/styled.js');
require('./const-7e9ce2ed.js');
var tooltip = require('./tooltip.js');
require('./index-cd777c24.js');
var modal = require('./modal.js');
var fullPageModal = require('./full-page-modal.js');
var componentTooltip = require('./tooltip/component-tooltip.js');
var badge = require('./badge.js');
var dropdownMenuWithCircleHover = require('./menu-dropdown/dropdown-menu-with-circle-hover.js');
var errorAlert = require('./alert/error-alert.js');
var withModal = require('./with-modal.js');
var dropUpload = require('./drop-upload.js');
require('lodash/toInteger');
var unsupportBrowser = require('./templates/unsupport-browser.js');
var benefitCard = require('./cards/benefit-card.js');
var initialBox = require('./initial-box.js');
var tabsBar = require('./tabs-bar.js');
var section$1 = require('./section.js');
require('lodash/isEmpty');
var agentBadge = require('./index-289206a4.js');
require('lodash');
var pagination = require('./pagination.js');
require('lodash/range');
require('react-player');
var videoPlayer = require('./video-player.js');

var _templateObject = _babelHelpers.taggedTemplateLiteral(["\n  display: inline-block;\n  &.badgeOverlap {\n    position: relative;\n    ", "\n    :before {\n      content: '", "';\n      font-family: ", ";\n      font-size: 9px;\n      font-weight: 600;\n      text-align: center;\n      color: ", ";\n      font-style: italic;\n      position: absolute;\n      z-index: 1;\n      border-radius: 3px;\n      background-color: ", ";\n      transform: translate(50%,-35%);\n      width: 20px;\n      height: 10px;\n      line-height: 10px;\n      right: 0;\n      top: 0;\n      ", "\n    }\n  }\n"], ["\n  display: inline-block;\n  &.badgeOverlap {\n    position: relative;\n    ", "\n    :before {\n      content: '", "';\n      font-family: ", ";\n      font-size: 9px;\n      font-weight: 600;\n      text-align: center;\n      color: ", ";\n      font-style: italic;\n      position: absolute;\n      z-index: 1;\n      border-radius: 3px;\n      background-color: ", ";\n      transform: translate(50%,-35%);\n      width: 20px;\n      height: 10px;\n      line-height: 10px;\n      right: 0;\n      top: 0;\n      ", "\n    }\n  }\n"]);

var BadgeWrapper = styled__default.div(_templateObject, function (props) {
  return props.stylesContainer ? props.stylesContainer : "";
}, function (props) {
  return props.content;
}, function (props) {
  return props.fontFamily ? props.fontFamily : "Source Sans Pro, sans-serif";
}, function (props) {
  return props.color ? props.color : settings.COLOR.white;
}, function (props) {
  return props.background ? props.background : settings.COLOR.orange;
}, function (props) {
  return "\n        " + (props.transform ? "transform: " + props.transform + ";" : "") + "\n        " + (props.fontSize ? "font-size: " + props.fontSize + ";" : "") + "\n        " + (props.width ? "width: " + props.width + ";" : "") + "\n        " + (props.height ? "height: " + props.height + ";" : "") + "\n        " + (props.borderRadius ? "border-radius: " + props.borderRadius + ";" : "") + "\n        " + (props.styles ? props.styles : "") + "\n      ";
});

var BadgeOverlap = function BadgeOverlap(_ref) {
  var children = _ref.children,
      showBadge = _ref.showBadge,
      _ref$content = _ref.content,
      content = _ref$content === undefined ? "New" : _ref$content,
      transform = _ref.transform,
      fontSize = _ref.fontSize,
      width = _ref.width,
      height = _ref.height,
      borderRadius = _ref.borderRadius,
      color = _ref.color,
      background = _ref.background,
      fontFamily = _ref.fontFamily,
      styles = _ref.styles,
      stylesContainer = _ref.stylesContainer;
  return React__default.createElement(
    BadgeWrapper,
    {
      className: showBadge ? "badgeOverlap" : "",
      content: content,
      transform: transform,
      fontSize: fontSize,
      width: width,
      height: height,
      borderRadius: borderRadius,
      color: color,
      background: background,
      fontFamily: fontFamily,
      styles: styles,
      stylesContainer: stylesContainer },
    children
  );
};
BadgeOverlap.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BadgeOverlap",
  "props": {
    "content": {
      "defaultValue": {
        "value": "\"New\"",
        "computed": false
      },
      "required": false
    }
  }
};

var _templateObject$1 = _babelHelpers.taggedTemplateLiteral(["\n  display: flex;\n  width: ", ";\n  min-height: 74px;\n  flex-direction: row;\n  border-radius: 5px;\n  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.1);\n  ", "\n"], ["\n  display: flex;\n  width: ", ";\n  min-height: 74px;\n  flex-direction: row;\n  border-radius: 5px;\n  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.1);\n  ", "\n"]),
    _templateObject2 = _babelHelpers.taggedTemplateLiteral(["\n  border-radius: 5px 0 0 5px;\n  border-left: 5px solid ", ";\n"], ["\n  border-radius: 5px 0 0 5px;\n  border-left: 5px solid ", ";\n"]),
    _templateObject3 = _babelHelpers.taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  margin: 11px 20px 11px 15px;\n  flex-direction: column;\n"], ["\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  margin: 11px 20px 11px 15px;\n  flex-direction: column;\n"]),
    _templateObject4 = _babelHelpers.taggedTemplateLiteral(["\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  flex-wrap: wrap;\n"], ["\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  flex-wrap: wrap;\n"]),
    _templateObject5 = _babelHelpers.taggedTemplateLiteral(["\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n"], ["\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n"]),
    _templateObject6 = _babelHelpers.taggedTemplateLiteral(["\n  font-size: 24px;\n  color: ", ";\n  font-weight: 600;\n  line-height: 32px;\n"], ["\n  font-size: 24px;\n  color: ", ";\n  font-weight: 600;\n  line-height: 32px;\n"]),
    _templateObject7 = _babelHelpers.taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n"], ["\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n"]);

var CardContainer = styled__default.div(_templateObject$1, function (props) {
  return props.width || "100%";
}, function (props) {
  return props.margin && "margin: " + props.margin;
});

var Highlight = styled__default.div(_templateObject2, function (props) {
  return props.highLightColor;
});

var Content = styled__default.div(_templateObject3);

var SubContent = styled__default.div(_templateObject4);

var Title = styled__default.div(_templateObject5);

var ContentDeatil = styled__default.div(_templateObject6, function (props) {
  return props.highLightColor;
});

var SubContentDeatil = styled__default.div(_templateObject7);

var SummaryCard = function SummaryCard(_ref) {
  var highLightColor = _ref.highLightColor,
      title = _ref.title,
      content = _ref.content,
      subContent = _ref.subContent,
      margin = _ref.margin,
      width = _ref.width;
  return React__default.createElement(
    CardContainer,
    { margin: margin, width: width },
    React__default.createElement(Highlight, { highLightColor: highLightColor }),
    React__default.createElement(
      Content,
      null,
      React__default.createElement(
        SubContent,
        null,
        React__default.createElement(
          Title,
          null,
          title
        )
      ),
      React__default.createElement(
        SubContent,
        null,
        React__default.createElement(
          ContentDeatil,
          { highLightColor: highLightColor },
          content
        ),
        React__default.createElement(
          SubContentDeatil,
          null,
          subContent
        )
      )
    )
  );
};

SummaryCard.propTypes = {
  /** Highlight in card summary color */
  highLightColor: PropTypes$1.string,
  /** Title of the card */
  title: PropTypes$1.string.isRequired,
  /** ContentDeatil */
  content: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]).isRequired,
  /** Sub content of the card */
  subContent: PropTypes$1.oneOfType([PropTypes$1.string, PropTypes$1.number]).isRequired,
  /** Margin for the card */
  margin: PropTypes$1.string,
  /** Width for the card */
  width: PropTypes$1.string
};

SummaryCard.defaultProps = {
  highLightColor: "#f15555"
};
SummaryCard.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SummaryCard",
  "props": {
    "highLightColor": {
      "defaultValue": {
        "value": "\"#f15555\"",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Highlight in card summary color"
    },
    "title": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Title of the card"
    },
    "content": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": true,
      "description": "ContentDeatil"
    },
    "subContent": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": true,
      "description": "Sub content of the card"
    },
    "margin": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Margin for the card"
    },
    "width": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Width for the card"
    }
  }
};

exports.RedText = sharedComponents.RedText;
exports.SelectDropdown = select.default;
exports.CountryDropdown = country;
exports.GlobalStyle = global;
exports.SearchDropdown = search;
exports.TextInput = text.default;
exports.PreventInput = prevent.default;
exports.B14 = b14.default;
exports.Icon = icon.Icon;
exports.TextArea = textarea.default;
exports.PasswordInput = password.default;
exports.FormattedInput = formatted.default;
exports.InternationalPhoneInput = internationalPhone.default;
exports.Hr = hr.default;
exports.Alert = alert;
exports.Checkbox = checkbox;
exports.Span = span;
exports.B18 = b18.default;
exports.B16 = b16.default;
exports.RadioButton = radioButton;
exports.RadioGroupWithTextArea = radioTextarea;
exports.S24 = s24.default;
exports.RadioGroupWithConditionalFields = radioConditionalField;
exports.S16 = s16.default;
exports.RadioButtonCard = radioButtonCard;
exports.TransparentButton = transparent.default;
exports.ArrayFieldGroupContainer = container;
exports.S18 = s18.default;
exports.ArrayFieldGroupItem = item.default;
exports.withFormikArrayField = index$1;
exports.TermText = text$1;
exports.TermBox = box.default;
exports.TermSection = section;
exports.TermList = list.default;
exports.USStateDropdown = usState;
exports.StepProgress = stepProgress.default;
exports.T24 = t24.default;
exports.ButtonIcon = buttonIcon.default;
exports.MobileInfoOverlay = mobileInfoOverlay.default;
exports.TagsInput = tags;
exports.InputGroupWithTrail = withTrail.default;
exports.Slider = slider.default;
exports.T36 = t36.default;
exports.T20 = t20.default;
exports.S20 = s20.default;
exports.DateInput = date;
exports.Button = index$3;
exports.BlueGradientButton = gradient.BlueGradientButton;
exports.BlueGradientButtonBadge = gradient.BlueGradientButtonBadge;
exports.RedGradientButton = gradient.RedGradientButton;
exports.SecondaryGradientButton = gradient.SecondaryGradientButton;
exports.YellowGradientButton = gradient.YellowGradientButton;
exports.BackButton = back;
exports.RedButton = redButton.default;
exports.Link = link.default;
exports.Switch = _switch.default;
exports.InfoBox = infoBox;
exports.Tooltip = tooltip;
exports.RentSpreeModal = modal;
exports.RentSpreeFullPageModal = fullPageModal;
exports.ComponentTooltip = componentTooltip;
exports.Badge = badge.default;
exports.DropdownMenuWithCircleHover = dropdownMenuWithCircleHover;
exports.ErrorAlert = errorAlert;
exports.WithModal = withModal.default;
exports.DropUpload = dropUpload.DropUpload;
exports.FullScreenDropUpload = dropUpload.FullScreenDropUpload;
exports.UnSupportBrowser = unsupportBrowser.UnSupportBrowser;
exports.BenefitCard = benefitCard.BenefitCard;
exports.InitialBox = initialBox;
exports.TabsBar = tabsBar.TabsBar;
exports.Section = section$1.Section;
exports.AgentBadge = agentBadge.AgentBadge;
exports.SimpleTooltip = agentBadge.SimpleTooltip;
exports.Pagination = pagination;
exports.VideoPlayer = videoPlayer;
exports.BadgeOverlap = BadgeOverlap;
exports.SummaryCard = SummaryCard;
//# sourceMappingURL=index.js.map
